/* unplugin-vue-components disabled */import { render } from "./IconSprite.vue?vue&type=template&id=1a3a1906"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__